import { Card } from "@components/_Revamp/StyledComponent";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";

import React, {
  useCallback,
  useEffect,
  useReducer,
  useRef,
  useState,
} from "react";
import { themeDefault } from "src/theme-revamp";
import Button from "@components/_Revamp/Button";
import Checkbox from "@pages/CCP/components/Checkbox";

import Input from "@components/_Revamp/Input";
import { get, isEmpty, startCase } from "lodash";
import { CCP_API_ADDRESS, getAddressWithPostalCode } from "@api/index";
import { useHistory } from "react-router";
import { ROUTE_PATH } from "@static/route-paths";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  updateIsMailingAddressConfirmed,
  updateMailingAddressState,
} from "@redux/slices/CCP/step4Slice";
import {
  QASPostalCodeRequest,
  QASPostalCodeResponse,
} from "@models/QASPostalCodeRequest";
import { Validations } from "@utils/helpers";
import { calculateSpacer } from "@utils/spaceCalculation";
import { scrollToRef } from "@utils/scrollScript";
import { Tooltip } from "@pages/CCP/components/Tooltip";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { SCREEN_SIZE } from "@static/screen-size";
import { setLoadingState } from "@redux/slices/loadingSlice";
import Dropdown from "@pages/CCP/components/Dropdown";
import { Nationalities } from "@static/nationalities";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { AA } from "@utils/adobeAnalyticsSS";
import { CCPDataLayer } from "@pages/CCP/DataLayer/Datalayer.model";
import { store } from "@redux/store";
import { ContainerWithStepper } from "@pages/CCP/components/ContainerWithStepper";

const Header = styled.div<{ maxWidth?: string }>`
  font-size: 28px;
  max-width: 327px;
  margin: 0 auto;
  font-weight: 600;
  text-align: center;
  color: #434343;
  @media screen and (max-width: 767px) {
    font-size: 18px;
  }
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    white-space: break-spaces;
    max-width: 583px;
  }
`;

const SpiltUpContainer = styled.div<{ mariginTop?: string }>`
  max-width: 100%;
  display: flex;
  margin-top: ${(props) => props.mariginTop || "60px"};
  & div {
    width: 100%;
    flex-grow: 1;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    margin-top: 0px;
    & div {
      display: flex;
      flex-direction: column;
      width: auto;
      flex-grow: 1;
      column-gap: 15px;
    }
  }
`;

const cardStyle = css`
  align-items: unset;
  background-color: white;
  padding: 24px;
`;

const cardStyleUpdateMail = css`
  align-items: unset;
  margin-top: 0;
  padding: 24px;
`;

const hideSytle = css`
  display: none;
  opacity: 0;
  transition: opacity 0.2s ease-in;
`;

const FieldLable = styled.div`
  font-size: 14px;
`;

const FieldValue = styled.div`
  font-style: normal;
  line-height: 140%;
  color: #434343;
  margin-top: 16px;
  font-weight: 600;
  font-size: 14px;
  @media screen and (max-width: 767px) {
    margin-bottom: 32px;
    font-size: 14px;
  }
`;

const CardDescription = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  @media screen and (max-width: 767px) {
    margin-bottom: 36px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  justify-content: center;
  margin-top: 80px;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;

const countryStyle = css`
  display: flex;
  width: 100%;
  height: 66px;
  gap: 24px;
  label {
    font-size: 12px;
  }
  &:nth-child(1) {
    & input {
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 767px) {
    height: auto;
  }
`;

const postalCodeStyle = css`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 24px;
  label {
    font-size: 12px;
  }
  &:nth-child(1) {
    & input {
      margin-top: 10px;
    }
  }
  @media screen and (max-width: 767px) {
    height: auto;
  }
`;
const postalCodeInputStyle = css`
  display: flex;
  height: 66px;
  align-items: flex-start;
  gap: 24px;

  label {
    font-size: 12px;
  }
  & > div {
    & input {
      margin-top: 10px;
    }
    width: 100%;
    & input {
      max-width: 100%;
    }
  }

  @media screen and (max-width: 767px) {
    height: auto;
    & > div {
      margin-top: 22px;
    }
  }
`;

const unitNoCss = css`
  div:first-child {
    width: auto;
    flex-grow: unset;
  }
`;

const checkboxDifferentEmail = css`
  padding: 24px;
  display: block;
`;

const noteText = css`
  font-size: 12px;
  font-weight: 500;
  width: 100%;
  margin-top: 36px;
`;
const searchBtnCss = css`
  width: 100%;
  max-width: unset;
`;
const Disclaimer = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 500;
  margin-left: 5%;
  @media screen and (max-width: 767px) {
    margin-left: 38px;
    margin-top: 5px;
  }
`;

const InvalidPostCodeMsg = styled.p`
  color: #c50000;
  margin-top: 7px;
  font-weight: 600;
  font-size: 12px;
`;

const LooksGoodStyle = styled.button<{ disabled: boolean }>`
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px 60px;
  font-weight: 600;
  width: 282px;
  height: 52px;
  background: #883E89;
  border-radius: 101px;
  align-items: center;
  text-align: center;
  transition: all 0.1s linear;
  color: #fff;
  font-size: 14px;
  cursor: ${(prop) => (prop.disabled ? "auto" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.25 : 1)};
`;

const UpdateEmailContainer = styled.div`
  border-radius: 8px;
`;

enum InputState {
  UPDATE_BLOCK_NUMBER,
  UPDATE_UNIT_NUMBER,
  UPDATE_STREET_NAME,
  UPDATE_POST_CODE,
  UPDATE_BUILDING_NAME,
  UPDATE_ADDRESS,
  UPDATE_MAIL_ADDRESS_FOR_ALL,
  UPDATE_ENTIRE_MAILADDRESS,
  UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE,
  UPDATE_COUNTRY_CODE,
}

function MailingAddress() {
  const [invalidPostalCode, setInvalidPostalCode] = useState("");
  const [isDirty, setIsDirty] = useState(false);
  const [isLooksGoodEnabled, setIsLooksGoodEnabled] = useState(false);
  const residentialAddress = useAvivaSelector(
    (state) => state.cancerCoverStep4.myInfo?.address
  );
  const mailingAddress = useAvivaSelector(
    (state) => state.cancerCoverStep4.myInfo?.mailingAddress
  );
  const isMyInfoSubmitted = useAvivaSelector(
    (state) => state.cancerCoverStep4.isMyInfoSumbitted
  );
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const [isInvalidUnitNo, setIsInvalidUnitNo] = useState(false);
  const [isInValidBlock, setIsInValidBlock] = useState(false);
  const [isInvalidStreet, setIsInvalidStreet] = useState(false);
  const mailingAddressUpdateFormRef = useRef<null | HTMLDivElement>(null);
  const mailingAddressOriginalFormRef = useRef<null | HTMLDivElement>(null);
  const [addressData, dispatchAddressAction] = useReducer(reducer, {
    block: "",
    unitNo: "",
    street: "",
    postal: "",
    building: "",
    useDifferentMailing:
      mailingAddress?.useMailAddressForAll === null ||
      mailingAddress?.useMailAddressForAll === undefined
        ? undefined
        : mailingAddress?.useMailAddressForAll === "Y"
        ? false
        : true,
    useMailAddressForAll:
      mailingAddress?.useMailAddressForAll === null ||
      mailingAddress?.useMailAddressForAll === undefined
        ? undefined
        : mailingAddress?.useMailAddressForAll === "Y"
        ? true
        : false,
    ...(mailingAddress || {}),
  });
  const myinfotransactionId = useAvivaSelector(
    (state) => state.cancerCoverStep4.myinfoTransactionId
  );
  const customerId = useAvivaSelector(
    (state) => state.cancerCoverStep4.myInfo.customerId
  );
  const SpacerRef = useRef<null | HTMLDivElement>(null);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const isSearched = useRef<boolean>(false);

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  useEffect(() => {
    const digiData = AA.getInstance().digitalData as CCPDataLayer;
    const storeData = store.getState();
    trackOnLoad({
      acquisitionUpdated: {
        customer: {
          ...digiData.acquisition.customer,
          marketingOptIn:
            storeData.cancerCoverStep4.rentalPostalCustomer === "false"
              ? "No"
              : "Yes",
        },
      },
      formUpdated: {
        field: {
          Gender:
            storeData.cancerCoverStep1.basicInfo?.forwhom === "child"
              ? storeData.cancerCoverStep4.selectedChildInfo?.gender || ""
              : storeData.cancerCoverStep4.myInfo.gender,
        },
      },
    });
  }, []);

  function noChangeMailingAddress() {
    setTimeout(() => {
      if (
        mailingAddressUpdateFormRef &&
        mailingAddressUpdateFormRef.current &&
        mailingAddressOriginalFormRef &&
        mailingAddressOriginalFormRef.current
      ) {
        let unit = -100;
        screenSize < SCREEN_SIZE.mobilesUp && (unit = 20);
        screenSize > SCREEN_SIZE.mobilesUp &&
          screenSize < SCREEN_SIZE.mobileSteper &&
          (unit = -136);

        const elementOffSetTop =
          mailingAddressOriginalFormRef.current.offsetTop;
        calculateSpacer(mailingAddressUpdateFormRef, SpacerRef, false);
        const top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          unit,
          top,
          elementOffSetTop,
          300,
          true,
          () => {
            if (mailingAddressUpdateFormRef.current) {
              mailingAddressUpdateFormRef.current.style.display = "none";
            }
          }
        );
        mailingAddressUpdateFormRef.current.style.opacity = "0.25";
        mailingAddressUpdateFormRef.current.style.pointerEvents = "none";
      }
    }, 100);
    //TODO Set the next page once it's created
    dispatch(updateMailingAddressState(null));
  }

  function setMailingForAll() {
    dispatchAddressAction({
      type: InputState.UPDATE_MAIL_ADDRESS_FOR_ALL,
      useMailAddressForAll: !addressData.useMailAddressForAll,
    });
  }
  const scrollToUpdateMail = useCallback(() => {
    setTimeout(() => {
      if (mailingAddressUpdateFormRef && mailingAddressUpdateFormRef.current) {
        mailingAddressUpdateFormRef.current.style.display = "block";
        let unit = -100;
        screenSize < SCREEN_SIZE.mobilesUp && (unit = 20);
        screenSize > SCREEN_SIZE.mobilesUp &&
          screenSize < SCREEN_SIZE.mobileSteper &&
          (unit = -136);

        const elementOffSetTop = mailingAddressUpdateFormRef.current.offsetTop;
        calculateSpacer(mailingAddressUpdateFormRef, SpacerRef, false);
        const top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          unit,
          top,
          elementOffSetTop,
          300,
          true
        );
        mailingAddressUpdateFormRef.current.style.opacity = "1";
        mailingAddressUpdateFormRef.current.style.pointerEvents = "auto";
      }
    }, 500);
  }, [screenSize]);
  function reducer(state: any, payload: any) {
    switch (payload.type) {
      case InputState.UPDATE_ADDRESS: {
        if (!isDirty) {
          setIsDirty(true);
        }
        return { ...state, ...payload?.address };
      }
      case InputState.UPDATE_BLOCK_NUMBER: {
        return { ...state, block: payload?.block };
      }
      case InputState.UPDATE_UNIT_NUMBER: {
        return { ...state, unitNo: payload?.unitNo };
      }
      case InputState.UPDATE_STREET_NAME: {
        return { ...state, street: payload?.street };
      }
      case InputState.UPDATE_POST_CODE: {
        return { ...state, postal: payload?.postal };
      }
      case InputState.UPDATE_BUILDING_NAME: {
        return { ...state, building: payload?.building };
      }
      case InputState.UPDATE_MAIL_ADDRESS_FOR_ALL: {
        return { ...state, useMailAddressForAll: payload.useMailAddressForAll };
      }
      case InputState.UPDATE_ENTIRE_MAILADDRESS: {
        return { ...state, useDifferentMailing: payload.useDifferentMailing };
      }
      case InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE: {
        return { ...state, ...payload.mailingaddress };
      }
      case InputState.UPDATE_COUNTRY_CODE: {
        return { ...state, country: payload.country };
      }
      default:
        return state;
    }
  }

  const validatePostCode = useCallback(() => {
    if (!isSearched.current) return;
    if (!/[0-9]{6}/.test(addressData.postal)) {
      setInvalidPostalCode("Please enter a valid postal code");
    } else {
      setInvalidPostalCode("");
    }
  }, [addressData.postal]);

  function setPostalCodeValue(value: string) {
    if (invalidPostalCode) {
      setInvalidPostalCode("");
    }
    //TODO: Check with business if changing the postal code needs to erase all the fields
    // dispatchAddressAction({
    //   type: InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE,
    //   mailingaddress: {
    //     block: "",
    //     unitNo: "",
    //     street: "",
    //     postal: "",
    //     building: ""
    //   },
    // });
    dispatchAddressAction({
      type: InputState.UPDATE_POST_CODE,
      postal: value,
    });
  }

  async function fetchAddressWithPostalCode() {
    // trackOnStart("search_postal_code")

    let zipcode = addressData.postal;
    const payload = new QASPostalCodeRequest({
      postalCode: zipcode,
    });
    try {
      const response = await getAddressWithPostalCode(payload, CCP_API_ADDRESS);
      const data = get(response, "data");
      if (!data.valid) {
        setInvalidPostalCode(
          "We couldn't find your postal code. Enter your address below."
        );
        return;
      }
      const address = new QASPostalCodeResponse(data);
      const unit = get(address, "addressLine3", undefined);
      let addressRestructured = {
        block: get(address, "addressLine1", ""),
        unitNo: isEmpty(unit) ? undefined : unit,
        street: get(address, "addressLine2", ""),
        building: get(address, "addressLine4", ""),
        postal: zipcode,
        useDifferentMailing: true,
      };

      isSearched.current = true;
      dispatchAddressAction({
        type: InputState.UPDATE_ADDRESS,
        address: addressRestructured,
      });
    } catch (error) {
      history.push(ROUTE_PATH.CANCER_COVER_SINGPASS);
    }
  }

  async function updateMailingAddress() {
    //update the mailing address in Store and goto next page
    dispatch(setLoadingState(true));
    try {
      const isSameAsResidentialAddress = addressData?.useDifferentMailing
        ? "N"
        : "Y";
      let addressPayload: any = {
        isSameAsResidentialAddress,
        customerId,
      };
      if (isSameAsResidentialAddress === "N") {
        addressPayload = {
          ...addressPayload,
          block: addressData.block,
          unitNo: addressData.unitNo,
          street: addressData.street,
          postalCode: addressData.postal,
          building: addressData.building,
          useMailAddressForAll: isSameAsResidentialAddress,
        };
      }
      const payload = new QASPostalCodeRequest(addressPayload);
      await getAddressWithPostalCode(payload, CCP_API_ADDRESS);
      if (isSameAsResidentialAddress === "Y") {
        dispatch(updateMailingAddressState(null));
      } else {
        dispatch(
          updateMailingAddressState({
            ...addressData,
            useMailAddressForAll: addressData?.useDifferentMailing ? "N" : "Y",
          })
        );
      }
      dispatch(updateIsMailingAddressConfirmed(true));
      history.push(ROUTE_PATH.CANCER_COVER_DECLARATION);
      dispatch(setLoadingState(false));
      trackOnCTA({
        ctaText: "Yes, proceed",
        ctaType: "qb:link",
      });
    } catch (error) {
      history.push(ROUTE_PATH.CANCER_COVER_SINGPASS);
      dispatch(setLoadingState(false));
    }
  }

  function onChangeDifrerent(e: any) {
    if (addressData.useDifferentMailing === undefined) {
      scrollToUpdateMail();
      dispatchAddressAction({
        type: InputState.UPDATE_ENTIRE_MAILADDRESS,
        useDifferentMailing: true,
      });
    } else {
      if (addressData.useDifferentMailing === true) {
        noChangeMailingAddress();
        dispatchAddressAction({
          type: InputState.UPDATE_ENTIRE_MAILADDRESS,
          useDifferentMailing: false,
        });
      } else {
        scrollToUpdateMail();
        dispatchAddressAction({
          type: InputState.UPDATE_ENTIRE_MAILADDRESS,
          useDifferentMailing: true,
        });
      }
    }
  }

  useEffect(() => {
    if (
      /.{4,10}/.test(addressData.postal) &&
      addressData.street &&
      addressData.block
    ) {
      if (isInvalidUnitNo || !/[0-9]{6}/.test(addressData.postal)) {
        setIsLooksGoodEnabled(false);
        return;
      }
      setIsLooksGoodEnabled(true);
    } else {
      setIsLooksGoodEnabled(false);
    }
  }, [
    addressData.block,
    addressData.postal,
    addressData.postal.length,
    addressData.street,
    addressData.unitNo,
    isInvalidUnitNo,
  ]);

  useEffect(() => {
    if (mailingAddress) {
      if (mailingAddress?.useMailAddressForAll === "N") scrollToUpdateMail();
      dispatchAddressAction({
        type: InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE,
        mailingaddress: mailingAddress,
      });
    }
  }, [mailingAddress, scrollToUpdateMail]);

  useEffect(() => {
    if (addressData.postal?.length) {
      validatePostCode();
    }
  }, [addressData.postal?.length, validatePostCode]);

  useEffect(() => {
    if (!isMyInfoSubmitted) return;
  }, []);

  // if (!isMyInfoSubmitted) {
  //   history.push(ROUTE_PATH.CANCER_COVER_MY_INFO);
  //   return <></>;
  // }

  return (
    <>
      <ContainerWithStepper
        currentStep={ROUTE_PATH.CANCER_COVER_MY_INFO}
        backButtonPath={`${ROUTE_PATH.CANCER_COVER_MY_INFO}?transaction_id=${myinfotransactionId}`}
      >
        <div ref={mailingAddressOriginalFormRef}>
          <Header>
            Is your residential address the same as your mailing address?
          </Header>
          <Card className={cardStyle} opacityValue="unset">
            <>
              <CardDescription>Residential Address</CardDescription>
              <SpiltUpContainer mariginTop="36px">
                <div>
                  <FieldLable>Block</FieldLable>
                  <FieldValue>{residentialAddress?.block || "-"}</FieldValue>
                </div>
                <div>
                  <FieldLable>Unit Number (If any)</FieldLable>
                  <FieldValue>{residentialAddress?.unitNo || "-"}</FieldValue>
                </div>
              </SpiltUpContainer>
              <SpiltUpContainer mariginTop="44px">
                <div>
                  <FieldLable>Street Name</FieldLable>
                  <FieldValue>
                    {startCase(residentialAddress?.street?.toLowerCase()) ||
                      "-"}
                  </FieldValue>
                </div>
                <div>
                  <FieldLable>Postal Code</FieldLable>
                  <FieldValue>{residentialAddress?.postal || "-"}</FieldValue>
                </div>
              </SpiltUpContainer>
              <SpiltUpContainer mariginTop="44px">
                <div>
                  <FieldLable>Building Name (If any)</FieldLable>
                  <FieldValue>
                    {startCase(residentialAddress?.building?.toLowerCase()) ||
                      "-"}
                  </FieldValue>
                </div>
              </SpiltUpContainer>
            </>
          </Card>
          <UpdateEmailContainer>
            <span className={checkboxDifferentEmail}>
              <Checkbox
                name="diff-mail-address"
                onChange={onChangeDifrerent}
                label="No, I have a different mailing address"
                checked={addressData.useDifferentMailing}
              />
            </span>
            <div className={hideSytle} ref={mailingAddressUpdateFormRef}>
              <Card className={cardStyleUpdateMail}>
                <>
                  <CardDescription>Mailing Address</CardDescription>
                  <SpiltUpContainer mariginTop="28px">
                    <div className={postalCodeStyle}>
                      <div>
                        <FieldLable>Postal Code</FieldLable>
                        <>
                          <Input
                            margin={"13px 0 0 0"}
                            maxLength={6}
                            value={addressData.postal}
                            onChange={(e) => {
                              const value = e.target.value;
                              const regex = new RegExp(/^[0-9]+$/);
                              if (!regex.test(value)) return;
                              setPostalCodeValue(e.target.value);
                            }}
                            boxLabel="Postal Code"
                            invalid={!!invalidPostalCode}
                            onBlur={validatePostCode}
                            inputMode={"numeric"}
                            bgColor="transparent"
                            color={themeDefault.colors.primary}
                          />
                          {invalidPostalCode && (
                            <InvalidPostCodeMsg>
                              {invalidPostalCode}
                            </InvalidPostCodeMsg>
                          )}
                        </>
                      </div>
                      <div>
                        <Button
                          disabled={
                            !addressData.postal || addressData.postal.length < 6
                          }
                          onClick={() => fetchAddressWithPostalCode()}
                          label="Search"
                          margin={"7px 0px 7px 0px"}
                          bgColor="white"
                          textColor={themeDefault.colors.primary}
                          height="52px"
                          padding={"16px 24px"}
                        />
                      </div>
                    </div>
                  </SpiltUpContainer>
                  <SpiltUpContainer mariginTop="28px">
                    <div className={postalCodeInputStyle}>
                      <div>
                        <FieldLable>Block</FieldLable>
                        <Input
                          margin={"13px 0 0 0"}
                          value={addressData.block}
                          type="alphanumeric"
                          maxLength={30}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (isEmpty(value)) {
                              setIsInValidBlock(true);
                            } else {
                              setIsInValidBlock(false);
                            }
                            dispatchAddressAction({
                              type: InputState.UPDATE_BLOCK_NUMBER,
                              block: e.target.value,
                            });
                          }}
                          boxLabel="Block"
                          bgColor="transparent"
                          color={themeDefault.colors.primary}
                        />
                        {isInValidBlock && (
                          <InvalidPostCodeMsg>
                            Please enter a valid block.
                          </InvalidPostCodeMsg>
                        )}
                      </div>
                      <div>
                        <FieldLable>Street Name</FieldLable>
                        <Input
                          value={addressData.street}
                          type="alphanumeric"
                          maxLength={60}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (isEmpty(value)) {
                              setIsInvalidStreet(true);
                            } else {
                              setIsInvalidStreet(false);
                            }
                            dispatchAddressAction({
                              type: InputState.UPDATE_STREET_NAME,
                              street: e.target.value,
                            });
                          }}
                          margin={"13px 0 0 0"}
                          boxLabel="Street Name"
                          bgColor="transparent"
                          color={themeDefault.colors.primary}
                        />
                        {isInvalidStreet && (
                          <InvalidPostCodeMsg>
                            Please enter a valid street.
                          </InvalidPostCodeMsg>
                        )}
                      </div>
                    </div>
                  </SpiltUpContainer>
                  <SpiltUpContainer mariginTop="28px">
                    <div className={postalCodeInputStyle}>
                      <div className={unitNoCss}>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <FieldLable>Unit Number (If any)</FieldLable>
                          <Tooltip title="Unit Number" isIcon={true}>
                            <ul>
                              <li>
                                For unit number (HDB/condo), enter # followed by
                                numeric digits (e.g. #12-456)
                              </li>
                              <li>
                                For P.O. Box, enter the numeric digits (e.g.
                                12345)
                              </li>
                              <li>
                                For house number (landed property), enter
                                numeric digits (e.g. 23, 42, etc)
                              </li>
                            </ul>
                          </Tooltip>
                        </label>
                        <Input
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!value) {
                              setIsInvalidUnitNo(false);
                              dispatchAddressAction({
                                type: InputState.UPDATE_UNIT_NUMBER,
                                unitNo: value,
                              });
                              return;
                            }
                            if (
                              /(\d|#|-)/.test(value.slice(-1)) &&
                              value.length <= 10
                            ) {
                              dispatchAddressAction({
                                type: InputState.UPDATE_UNIT_NUMBER,
                                unitNo: value,
                              });
                              const pattern =
                                /^(#\d{1,3}-\d{1,5})$|(([0]{1}))$|^([0-9]{1,6})-([0-9]{1,6})$/;
                              if (!Validations.isValidUinit(value, pattern)) {
                                setIsInvalidUnitNo(true);
                              } else if (isInvalidUnitNo) {
                                setIsInvalidUnitNo(false);
                              }
                            }
                          }}
                          invalid={isInvalidUnitNo}
                          value={addressData.unitNo}
                          margin={"13px 0 0 0"}
                          boxLabel="Unit Number"
                          bgColor="transparent"
                          color={themeDefault.colors.primary}
                        />
                        {isInvalidUnitNo && (
                          <InvalidPostCodeMsg>
                            Please enter a valid unit
                          </InvalidPostCodeMsg>
                        )}
                      </div>
                      <div>
                        <FieldLable>Building Name (If any)</FieldLable>
                        <Input
                          type="alphanumeric"
                          maxLength={30}
                          onChange={(e) => {
                            dispatchAddressAction({
                              type: InputState.UPDATE_BUILDING_NAME,
                              building: e.target.value,
                            });
                          }}
                          value={addressData.building}
                          margin={"13px 0 0 0"}
                          boxLabel="Building Name"
                          bgColor="transparent"
                          color={themeDefault.colors.primary}
                        />
                      </div>
                    </div>
                  </SpiltUpContainer>
                  <SpiltUpContainer className={noteText}>
                    <span>
                      If your mailing address differs from your residential
                      address, it will apply only to this policy.
                    </span>
                  </SpiltUpContainer>
                </>
              </Card>
            </div>
          </UpdateEmailContainer>
        </div>
        <ButtonContainer>
          <LooksGoodStyle
            disabled={!isLooksGoodEnabled && addressData.useDifferentMailing}
            onClick={updateMailingAddress}
          >
            Yes, proceed
          </LooksGoodStyle>
        </ButtonContainer>
      </ContainerWithStepper>
    </>
  );
}

export default MailingAddress;
